import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
      <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
        <i className="ri-home-4-line"></i>
      </Link>
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
          {item.path ? (
            <Link to={item.path} className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}